// Firebase app + Auth initialization. Single source of truth for the
// Firebase SDK across the frontend — auth pages + useAuth hook all
// import `auth` from here.
//
// Phase 4: Firebase Auth is the only identity provider. lib/supabase.ts
// was removed in Phase 4 cleanup.
//
// All 6 config values come from build-time env vars (VITE_FIREBASE_*).
// They're public by design — Firebase web config is meant to ship in
// the browser bundle. Security is enforced by Firebase Auth's rules +
// Authorized Domains list in the Firebase Console, NOT by hiding the
// API key.

import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Guard against double-init under React StrictMode + Vite HMR. getApps()
// returns existing instances on hot reload, initializeApp throws if you
// re-call it with the same name.
const app: FirebaseApp = getApps().length === 0
  ? initializeApp(firebaseConfig)
  : getApps()[0];

export const auth: Auth = getAuth(app);
export default app;
